// extracted by mini-css-extract-plugin
module.exports = {"recipeTipShotImage":"RecipeTipShot_recipeTipShotImage__f_UdL"};